import React from 'react';
import { cn } from '@/lib/utils';

const Slider = React.forwardRef(({ 
  className, 
  value, 
  onValueChange, 
  min = 0, 
  max = 100, 
  step = 1, 
  ...props 
}, ref) => {
  const handleChange = (e) => {
    const newValue = parseFloat(e.target.value);
    if (onValueChange) {
      onValueChange([newValue]);
    }
  };

  const currentValue = Array.isArray(value) ? value[0] : value;
  const percentage = ((currentValue - min) / (max - min)) * 100;

  return (
    <div className="relative">
      <input
        ref={ref}
        type="range"
        min={min}
        max={max}
        step={step}
        value={currentValue}
        onChange={handleChange}
        className={cn(
          "w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-gray-900",
          "slider-thumb",
          className
        )}
        style={{
          background: `linear-gradient(to right, #7c3aed 0%, #7c3aed ${percentage}%, #374151 ${percentage}%, #374151 100%)`
        }}
        {...props}
      />
    </div>
  );
});

Slider.displayName = 'Slider';

export { Slider };
